<!--<div class="row">
  <div class="col-9">
    <label class="control-label" style="font-weight:bold;color:cornflowerblue">Danh sách giáo trình</label>
  </div>
  <div class="col-3">
    <button *ngIf="quyen_them===true" style="float:right" class="btn btn-info btn-bloc" (click)="adddata()">
      Thêm mới
    </button>
  </div>
</div>-->


<as-split unit="pixel"
          direction="vertical"
          [disabled]="false"
          [gutterSize]="10"
          style="height: calc(100vh - 100px); width: 100%">
  <as-split-area size="*" style="background-color:#fff; height: 100%">
    <as-split unit="pixel"
              direction="horizontal"
              [disabled]="false"
              [gutterSize]="10"
              style="height: 100%; width: 100%">
      <as-split-area size="600" style="background-color:#fff; height: 100%">
        <div class="title-group">
          <div class="left-group">
            <span>{{'Danh sách đăng ký' | translate}}</span>
            <div *ngIf="quyen_them===true" style="margin-left: 5px;">
              <div class="btn-group mb-1 mr-1" dropdown>
                <button class="btn dropdown-toggle btn-add" type="button" dropdownToggle>
                  <i class="fa fa-cog"></i>
                  {{'Tiện ích' | translate}}
                </button>
                <div *dropdownMenu class="dropdown-menu" role="menu">
                  <a class="dropdown-item" (click)="adddata()"><em class="mr-2 far fa-plus-square"></em>{{'Thêm đăng ký' | translate}}</a>
                  <a class="dropdown-item" (click)="editdata_dangky()"><em class="mr-2 far fa-edit"></em>{{'Sửa đăng ký' | translate}}</a>
                  <a class="dropdown-item" (click)="deleterow_dangky()"><em class="mr-2 far fa-trash-alt"></em>{{'Xóa đăng ký' | translate}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="margin-left: -20px;margin-top: -10px;overflow:auto">
          <div style="padding: 2px 10px 10px 10px;color:black !important;height: calc(100vh - 400px)">
            <table id="fixTable4" class="table table-striped table-bordered table-hover table-condensed">
              <thead>
                <!--<thead>-->
                <tr>
                  <th style="width:90px;text-align:center;background-color:#f3f8fc">STT</th>
                  <th style="width:100px;text-align:center;background-color:#f3f8fc">Ngày tạo</th>
                  <th style="width:100px;text-align:center;background-color:#f3f8fc">Ngày đăng ký</th>
                  <th style="width:100px;text-align:center;background-color:#f3f8fc">Khóa học</th>
                  <th style="width:110px;text-align:center;background-color:#f3f8fc">Gói phí</th>
                  <th style="width:110px;text-align:center;background-color:#f3f8fc">Giảm giá</th>
                  <th style="width:110px;text-align:center;background-color:#f3f8fc">Thực thu</th>
                  <th style="width:110px;text-align:center;background-color:#f3f8fc">Số buổi</th>
                  <th style="width:120px;text-align:center;background-color:#f3f8fc">Loại đăng ký</th>

                </tr>

                <tr class="filter-row">
                  <td style="text-align:center">

                    <!--<button class="btn btn-info btn-primary" (click)="search()">
          <i class="fas fa-search"></i>
          Tìm kiếm
        </button>-->
                  </td>

                  <td></td>
                  <td></td>
                  <td style="font-weight:bold">Tổng</td>
                  <td style="text-align:right;font-weight:bold">{{tong_giaphi | number:'1.0-0'}}</td>
                  <td style="text-align:right;font-weight:bold">{{tong_giamgia | number:'1.0-0'}}</td>
                  <td style="text-align:right;font-weight:bold">{{tong_thucthu | number:'1.0-0'}}</td>
                  <td style="text-align:center;font-weight:bold">{{tong_sobuoi | number}}</td>
                  <td></td>

                  <!--<td>
        <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
               [(ngModel)]="TimKiems.Ma" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
      </td>
      <td>
        <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
               [(ngModel)]="TimKiems.Ten" placeholder="Gõ ký tự và ấn enter" (keydown)=onKeydownEvent($event)>
      </td>
      <td>
        <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
               [(ngModel)]="TimKiems.Cha" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
      </td>
      <td>
        <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
               [(ngModel)]="TimKiems.GhiChu" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
      </td>-->



                </tr>

              </thead>
              <tbody style="max-height:calc(100vh - 475px);">
                <tr *ngFor="let u of datas" (dblclick)="editdata(u)" [ngClass]="{'rowItem_Selected': u.Id==tId}" (click)="selected(u)">
                  <td style="width:90px;text-align:center"><a>{{u.STT}}</a></td>
                  <td style="min-width:100px"><a>{{u.Created | date:'dd/MM/yyyy'}}</a></td>
                  <td style="min-width:100px"><a>{{u.NgayDangKy | date:'dd/MM/yyyy'}}</a></td>
                  <td style="min-width:100px"><a>{{u.KhoaHoc}}</a></td>
                  <td style="min-width:110px;color:red;text-align:right">{{u.GiaPhi | number}}</td>
                  <td style="min-width:110px;color:red;text-align:right">{{u.DuocGiam | number}}</td>
                  <td style="min-width:110px;color:red;text-align:right">{{u.ThucThu | number}}</td>
                  <td style="min-width:110px;text-align:center">{{u.SoBuoi}}</td>
                  <td style="min-width:120px">{{u.LoaiDangKy}}</td>


                  <!--<td style="width:100px;text-align:center">
        <a href="#" class="mb-1 far fa-trash-alt ng2-smart-action ng2-smart-action-custom-custom ng-star-inserted" (click)="deleterow(u)"> {{'Xóa' | translate}}</a>
      </td>-->

                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="width:100%">
          <div>
            <ul class="pagination">
              <li [ngClass]="{disabled: currentPage === 1}">
                <a (click)="setPage(1)"><<</a>
              </li>
              <li [ngClass]="{disabled:currentPage === totalPages}">
                <a (click)="setPage(currentPage + 1)">></a>
              </li>
              <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
                <a (click)="setPage(page.Id)">{{page.Id}}</a>
              </li>
              <li [ngClass]="{disabled:currentPage === 1}">
                <a (click)="setPage(currentPage - 1)"><</a>
              </li>
              <li [ngClass]="{disabled:currentPage === totalPages}">
                <a (click)="setPage(totalPages)">>></a>
              </li>
              <li>
                <input type="number" style="width:50px;height:23px;text-align:center" [(ngModel)]="pageSize" (blur)="search1()" />
              </li>
              <li><span style="font-weight:bold">Tổng số: {{totalItems | number}}</span></li>
            </ul>
          </div>
        </div>
      </as-split-area>

      <as-split-area size="*" style="background-color:#fff; height: 100%">
        <!-- Nội dung khung phải (có thể thêm gì tùy bạn) -->
        <div class="title-group">
          <div class="left-group">
            <span>{{'Danh sách số lần đóng tiền' | translate}}</span>
            <div *ngIf="quyen_them===true" style="margin-left: 5px;">
              <div class="btn-group mb-1 mr-1" dropdown>
                <button class="btn dropdown-toggle btn-add" type="button" dropdownToggle>
                  <i class="fa fa-cog"></i>
                  {{'Tiện ích' | translate}}
                </button>
                <div *dropdownMenu class="dropdown-menu" role="menu">
                  <a class="dropdown-item" (click)="adddata_donghoc()"><em class="mr-2 far fa-plus-square"></em>{{'Thêm nộp tiền' | translate}}</a>
                  <a class="dropdown-item" (click)="editdata_donghoc()"><em class="mr-2 far fa-edit"></em>{{'Sửa nộp tiền' | translate}}</a>
                  <a class="dropdown-item" (click)="deleterow_donghoc()"><em class="mr-2 far fa-trash-alt"></em>{{'Xóa nộp tiền' | translate}}</a>
                  <a class="dropdown-item" (click)="adddata_datlich()"><em class="mr-2 far fa-calendar-alt"></em>{{'Đặt lịch' | translate}}</a>
                  <a class="dropdown-item" (click)="export('pdf')"><em class="mr-2 fas fa-print"></em>{{'In phiếu thu' | translate}}</a>
                  <a class="dropdown-item" (click)="export('xlsx')"><em class="mr-2 fas fa-file-excel"></em>{{'In phiếu thu - excel' | translate}}</a>
                  <a class="dropdown-item" (click)="export2('pdf')"><em class="mr-2 fas fa-print"></em>{{'In phiếu thu (2 liên)' | translate}}</a>
                  <a class="dropdown-item" (click)="export2('xlsx')"><em class="mr-2 fas fa-file-excel"></em>{{'In phiếu thu - excel(2 liên)' | translate}}</a>
                  <a class="dropdown-item" (click)="tuychinhmaubaocao()"><em class="mr-2 fas fa-broom"></em>Chỉnh sửa mẫu phiếu</a>
                  <a class="dropdown-item" (click)="tuychinhmaubaocao2()"><em class="mr-2 fas fa-broom"></em>Chỉnh sửa mẫu phiếu 2 liên</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="margin-left: -20px;margin-top: -10px;overflow:auto">
          <div style="padding: 2px 10px 10px 10px;color:black !important;height: calc(100vh - 400px)">
            <table id="fixTable5" class="table table-striped table-bordered table-hover table-condensed">
              <thead>
                <!--<thead>-->
                <tr>
                  <th style="width:90px;text-align:center;background-color:#f3f8fc">STT</th>
                  <th style="width:100px;text-align:center;background-color:#f3f8fc">Ngày tạo</th>
                  <th style="width:100px;text-align:center;background-color:#f3f8fc">Ngày nộp</th>
                  <th style="width:100px;text-align:center;background-color:#f3f8fc">Quyển</th>
                  <th style="width:110px;text-align:center;background-color:#f3f8fc">Số phiếu</th>
                  <th style="width:110px;text-align:center;background-color:#f3f8fc">Số tiền</th>


                </tr>

                <tr class="filter-row">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style="font-weight:bold">Tổng</td>
                  <td style="text-align:right;font-weight:bold">{{tong_tien | number:'1.0-0'}}</td>

                </tr>

              </thead>
              <tbody style="max-height:calc(100vh - 475px);">
                <tr *ngFor="let u of data2s" (dblclick)="editdata2(u)" [ngClass]="{'rowItem_Selected': u.Id==tId2}" (click)="selected2(u)">
                  <td style="width:90px;text-align:center"><a>{{u.STT}}</a></td>
                  <td style="min-width:100px"><a>{{u.Created | date:'dd/MM/yyyy'}}</a></td>
                  <td style="min-width:100px"><a>{{u.NgayNop | date:'dd/MM/yyyy'}}</a></td>
                  <td style="min-width:100px"><a>{{u.QuyenSo}}</a></td>
                  <td style="min-width:110px">{{u.SoPhieu}}</td>
                  <td style="min-width:110px;color:red;text-align:right">{{u.SoTien | number}}</td>



                  <!--<td style="width:100px;text-align:center">
        <a href="#" class="mb-1 far fa-trash-alt ng2-smart-action ng2-smart-action-custom-custom ng-star-inserted" (click)="deleterow(u)"> {{'Xóa' | translate}}</a>
      </td>-->

                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="width:100%">
          <div>
            <ul class="pagination">
              <li [ngClass]="{disabled: currentPage === 1}">
                <a (click)="setPage2(1)"><<</a>
              </li>
              <li [ngClass]="{disabled:currentPage2 === totalPage2s}">
                <a (click)="setPage2(currentPage2 + 1)">></a>
              </li>
              <li *ngFor="let page of page2s" [ngClass]="{active: currentPage2 === page.Id}">
                <a (click)="setPage2(page.Id)">{{page.Id}}</a>
              </li>
              <li [ngClass]="{disabled:currentPage === 1}">
                <a (click)="setPage2(currentPage2 - 1)"><</a>
              </li>
              <li [ngClass]="{disabled:currentPage2 === totalPage2s}">
                <a (click)="setPage2(totalPage2s)">>></a>
              </li>
              <li>
                <input type="number" style="width:50px;height:23px;text-align:center" [(ngModel)]="pageSize2" (blur)="search21()" />
              </li>
              <li><span style="font-weight:bold">Tổng số: {{totalItem2s | number}}</span></li>
            </ul>
          </div>
        </div>

      </as-split-area>
    </as-split>
  </as-split-area>

  <as-split-area size="220" style="background-color:#fff; height: 100%">
    <!-- Thanh bên dưới cùng -->
    <div class="title-group">
      <div class="left-group">
        <span>{{'Đặt lịch thu tiền' | translate}}</span>
      </div>
    </div>

    <div class="row" style="margin-left: -20px;margin-top: -10px;overflow:auto">
      <div style="padding: 2px 10px 10px 10px;color:black !important;height: 100%">
        <table id="fixTable6" class="table table-striped table-bordered table-hover table-condensed">
          <thead>
            <!--<thead>-->
            <tr>
              <th style="width:50px;text-align:center;background-color:#f3f8fc">STT</th>
              <th style="width:120px;text-align:center;background-color:#f3f8fc">Lịch thu</th>
              <th style="width:100px;text-align:center;background-color:#f3f8fc">Nội dung</th>
              <th style="width:100px;text-align:center;background-color:#f3f8fc">Số tiền</th>
              <th style="width:110px;text-align:center;background-color:#f3f8fc">Người đặt</th>
              <th style="width:110px;text-align:center;background-color:#f3f8fc">Ghi chú</th>
              <th style="width:110px;text-align:center;background-color:#f3f8fc">Ngày tạo</th>
              <th style="width:100px;text-align:center;background-color:#f3f8fc">Trạng thái</th>
              <th style="width:100px;text-align:center;background-color:#f3f8fc"></th>

            </tr>

            <!--<tr class="filter-row">


      </tr>-->

          </thead>
          <tbody style="height: 150px;">
            <tr *ngFor="let u of data3s" (dblclick)="editdata3(u)" [ngClass]="{'rowItem_Selected': u.Id==tId3}" (click)="selected3(u)">
              <td style="width:50px;text-align:center"><a>{{u.STT}}</a></td>
              <td style="width:120px"><a>{{u.Ngay | date:'dd/MM/yyyy HH:mm'}}</a></td>
              <td style="width:100px"><a>{{u.NoiDung}}</a></td>
              <td style="width:100px"><a>{{u.SoTien | number}}</a></td>
              <td style="width:110px">{{u.CreatedBy}}</td>
              <td style="width:110px">{{u.GhiChu}}</td>
              <td style="width:110px">{{u.Created | date:'dd/MM/yyyy'}}</td>
              <td style="width:100px">{{u.TrangThaiS}}</td>


              <td style="width:100px;text-align:center">
                <a class="mb-1 far fa-trash-alt ng2-smart-action ng2-smart-action-custom-custom ng-star-inserted" (click)="deleterow_DatLich(u)"> {{'Xóa' | translate}}</a>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div style="width:100%">
      <div>
        <ul class="pagination">
          <li [ngClass]="{disabled: currentPage3 === 1}">
            <a (click)="setPage3(1)"><<</a>
          </li>
          <li [ngClass]="{disabled:currentPage3 === totalPage3s}">
            <a (click)="setPage3(currentPage3 + 1)">></a>
          </li>
          <li *ngFor="let page of page3s" [ngClass]="{active: currentPage3 === page.Id}">
            <a (click)="setPage3(page.Id)">{{page.Id}}</a>
          </li>
          <li [ngClass]="{disabled:currentPage3 === 1}">
            <a (click)="setPage3(currentPage3 - 1)"><</a>
          </li>
          <li [ngClass]="{disabled:currentPage3 === totalPage3s}">
            <a (click)="setPage3(totalPage3s)">>></a>
          </li>
          <li>
            <input type="number" style="width:50px;height:23px;text-align:center" [(ngModel)]="pageSize3" (blur)="search31()" />
          </li>
          <li><span style="font-weight:bold">Tổng số: {{totalItem3s | number}}</span></li>
        </ul>
      </div>
    </div>

  </as-split-area>
</as-split>
<!-- lưới chi tiết -->
<!--<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">

  <div class="">

  </div>

</div>-->


<bs-modal #mdDangKyGoiHoc class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdDangKyGoiHoc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-dangkygoihocedit #dangkygoihocedit (save)="saveModalDangKy($event)"></app-daotao-dangkygoihocedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #mdDongHoc class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdDongHoc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-donghocedit #donghocedit (save)="saveModalDongHoc($event)"></app-daotao-donghocedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #mdDatLich class="modal fade show in" [cssClass]="'modal7'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdDatLich.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-datlichthuhocphiedit #datlichedit (save)="saveModalDatLich($event)"></app-daotao-datlichthuhocphiedit>
  </bs-modal-body>
</bs-modal>


<bs-modal #modaltuychinhmaubc class="modal fade show in" [cssClass]="'modal6'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="modaltuychinhmaubc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-quantri-tuychinhmaubcedit #dtsuamaubaocao></app-quantri-tuychinhmaubcedit>
  </bs-modal-body>
</bs-modal>


